/*
 * Progressive section rendering.
 *
 * Sections marked with `.cv-defer` start with `content-visibility: auto` (set in
 * the inlined critical CSS), so the browser skips their layout/paint work during
 * the initial page load. This observer flips each one to `content-visibility:
 * visible` (via `.cv-in`) shortly BEFORE it scrolls into view, which:
 *   1. renders it just in time (no visible pop-in with the 400px margin), and
 *   2. removes paint containment before the user can interact with it, so a
 *      position:fixed quick-add modal inside the section is never clipped.
 *
 * Fail-safe: if IntersectionObserver is unavailable, every deferred section is
 * revealed immediately (full render, original behaviour). No-JS is handled by a
 * <noscript> rule in the critical CSS.
 */
(function () {
  var sections = document.querySelectorAll('.cv-defer');
  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    for (var i = 0; i < sections.length; i++) sections[i].classList.add('cv-in');
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cv-in');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '400px 0px' });

  sections.forEach(function (section) { observer.observe(section); });
})();
